import tw, { TwComponent } from "twin.macro";

const Container: TwComponent<"section"> = tw.section`max-w-7xl mx-auto px-8 md:px-4`;

export default Container;
